// Story 8.10 (ADO-2019), AC1 / AC2 / DV-39: read the HHT waiting count once at sign-in, so
// the header can show "HHT Orders" with its waiting count on whatever page the Shopper
// lands on, without having to look for it. Only the cheap count: the classified details
// are read where they are shown (/choose and the HHT pages).
//
// The favourites precedent (`favourites/hydrateFavouritesOnAuth.ts`): a store
// subscription at the composition root (main.tsx), not a screen effect, so no screen's
// msw specs are coupled to the HHT endpoint. It is fire-and-forget: the store swallows a
// failure (no badge), so sign-in and the depot gate never wait on it or fail with it.

import { useAuthStore } from '../auth/useAuthStore';
import { useHhtWaitingCountStore } from './useHhtWaitingCountStore';

/**
 * Subscribe to the auth store and load the HHT waiting count exactly ONCE, the first time
 * the session settles into `ready && isAuthenticated`. Returns an unsubscribe handle
 * (for tests). Fires at once if the session is already authenticated when wired.
 */
export function startHhtOrdersLoadOnAuth(): () => void {
  let fired = false;

  const maybeLoad = (): void => {
    if (fired) return;
    const { status, isAuthenticated } = useAuthStore.getState();
    if (status !== 'ready' || !isAuthenticated) return;
    fired = true;
    unsubscribe();
    void useHhtWaitingCountStore.getState().load();
  };

  const unsubscribe = useAuthStore.subscribe(maybeLoad);
  maybeLoad();
  return unsubscribe;
}
